<template>
	<div class="home">
		<div class="content2 filter-content">
			<div class="header-row">
				<div class="page-title">数据统计</div>
				<div class="filter-group">
					<!-- 时间类型下拉选择器 -->
					<el-select v-model="timeType" placeholder="时间类型" class="time-type-select" @change="handleTimeTypeChange">
						<el-option label="签约时间" :value="1" />
						<el-option label="签约回传时间" :value="2" />
						<el-option label="解约回传时间" :value="3" />
						<el-option label="协议起期" :value="4" />
						<el-option label="协议止期" :value="5" />
						<el-option label="解约时间" :value="6" />
					</el-select>
					
					<el-radio-group v-model="timeRange" @change="handleTimeRangeChange" class="time-radio-group">
						<el-radio-button label="oneMonth">近一月</el-radio-button>
						<el-radio-button label="threeMonths">近三个月</el-radio-button>
						<el-radio-button label="sixMonths">近半年</el-radio-button>
						<el-radio-button label="oneYear">近一年</el-radio-button>
						<!-- <el-radio-button label="all">全部</el-radio-button> -->
						<el-radio-button label="custom">自定义</el-radio-button>
					</el-radio-group>

					<div class="date-picker-group" v-if="timeRange === 'custom'">
						<el-date-picker 
							value-format="timestamp" 
							@change="changeDaterange" 
							v-model="daterange"
							type="daterange" 
							range-separator="至" 
							start-placeholder="开始日期" 
							end-placeholder="结束日期"
							clearable 
						/>
						<el-button type="primary" plain icon="el-icon-search" @click="getData" class="search-btn">查询</el-button>
					</div>
					<el-button v-else type="primary" plain icon="el-icon-search" @click="getData" class="search-btn">查询</el-button>
				</div>
			</div>
		</div>

		<div class="num-box">
			<div class="num-item">
				<div class="num-item-left">
					<div class="num-item-icon money">
						<i class="el-icon-tickets"></i>
					</div>
					<div class="num-item-name">协议数量</div>
				</div>
				<div class="num-item-value">{{ data.num2 || 0 }}</div>
			</div>

			<div class="num-item">
				<div class="num-item-left">
					<div class="num-item-icon user">
						<i class="el-icon-money"></i>
					</div>
					<div class="num-item-name">费用(元)</div>
				</div>
				<div class="num-item-value">¥{{ formatAmount(data.num1 || 0) }}</div>
			</div>

			<div class="num-item">
				<div class="num-item-left">
					<div class="num-item-icon order">
						<i class="el-icon-document-remove"></i>
					</div>
					<div class="num-item-name">解约数量</div>
				</div>
				<div class="num-item-value">{{ data.num3 || 0 }}</div>
			</div>

			<div class="num-item">
				<div class="num-item-left">
					<div class="num-item-icon refund">
						<i class="el-icon-document-delete"></i>
					</div>
					<div class="num-item-name">失败数量</div>
				</div>
				<div class="num-item-value">{{ data.num4 || 0 }}</div>
			</div>
		</div>

		<div class="separate-content">
			<div class="map-chart">
				<div class="title">投保车辆所属地分布</div>
				<div class="echart" id="carLocationChart"></div>
			</div>
			<div class="pie-chart">
				<div class="title">协议类型分析</div>
				<div class="echart" id="userOrderChart"></div>
			</div>
		</div>

		<div class="element">
			<div class="title">保单走势</div>
			<div class="echart" id="orderChart"></div>
		</div>
	</div>
</template>

<script>
	import * as echarts from 'echarts';
	import chinaMap from '@/basic/tools/map.json';

	export default {
		data() {
			return {
				timeType: 1, // 时间类型，默认签约时间
				timeRange: 'oneMonth', // 默认近一月
				form: {
					beginTime: '',
					endTime: '',
					rangeType: 'oneMonth',
					timeType: 1
				},
				daterange: [],
				data: {
					num1: 0, // 总费用
					num2: 0, // 协议数量
					num3: 0, // 解约数量
					num4: 0, // 失败数量
					carLocationData: [], // 地图数据
					protocolTypeData: [], // 协议类型数据
					timeTrendData: [] // 时间趋势数据
				},
				charts: {},
				loading: false
			}
		},
		created() {
			this.initTimeRange();
			this.getData();
		},
		mounted() {
			// 监听窗口大小变化，重新渲染图表
			window.addEventListener('resize', this.handleResize);
			    
			// 确保 .home 可以滚动
			this.$nextTick(() => {
				const homeEl = this.$el; // 获取组件根元素
				if (homeEl) {
					homeEl.style.height = '100vh';
					homeEl.style.overflowY = 'auto';
				}
			});
		},
		methods: {
			formatAmount(amount) {
				return Number(amount).toLocaleString('zh-CN', {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2
				});
			},

			// 初始化时间范围
			initTimeRange() {
				this.calculateTimeRange('oneMonth');
			},

			// 处理时间类型切换
			handleTimeTypeChange(timeType) {
				this.timeType = timeType;
				this.form.timeType = timeType;
				this.getData();
			},

			// 处理时间范围切换
			handleTimeRangeChange(rangeType) {
				if (rangeType !== 'custom') {
					this.calculateTimeRange(rangeType);
					this.getData();
				}
			},

			// 计算时间范围并转换为时间戳
			calculateTimeRange(rangeType) {
				const now = new Date();
				let beginTime = new Date();

				switch (rangeType) {
					case 'oneMonth':
						beginTime.setMonth(now.getMonth() - 1);
						break;
					case 'threeMonths':
						beginTime.setMonth(now.getMonth() - 3);
						break;
					case 'sixMonths':
						beginTime.setMonth(now.getMonth() - 6);
						break;
					case 'oneYear':
						beginTime.setFullYear(now.getFullYear() - 1);
						break;
					case 'all':
						// 全部数据，开始日期设为一个很早的日期（2020-01-01）
						beginTime = new Date('2020-01-01');
						break;
					case 'custom':
						// 自定义范围，不自动设置日期
						return;
				}

				// 设置时间为当天的开始时间（00:00:00）
				beginTime.setHours(0, 0, 0, 0);
				now.setHours(0, 0, 0, 0);

				// 转换为时间戳
				this.form.beginTime = beginTime.getTime();
				this.form.endTime = now.getTime();

				// 更新日期选择器显示（如果是自定义模式）
				if (rangeType !== 'custom') {
					this.daterange = [beginTime.getTime(), now.getTime()];
				}
			},

			changeDaterange(e) {
				if (!e || e.length !== 2) {
					this.timeRange = 'oneMonth';
					this.calculateTimeRange('oneMonth');
				} else {
					// e已经是时间戳格式
					this.form.beginTime = e[0];
					this.form.endTime = e[1];
				}
			},

			// 获取统计数据
			async getData() {
				try {
					this.loading = true;
					this.$loading({
						text: '加载中...'
					});

					// 构建查询参数，确保所有时间都是时间戳
					const params = {
						timeType: this.timeType,
						timeRange: this.timeRange,
						beginTime: this.form.beginTime, // 时间戳
						endTime: this.form.endTime // 时间戳
					};

					// 调用后端接口获取统计数据
					const res = await this.$etcGet('order-protocol-info-do/get-home-data', params);
					
					if (res && res.code === 0) {
						const data = res.result || res.data;
						this.processStatisticsData(data);
						
						// 初始化所有图表
						this.$nextTick(() => {
							this.initCarLocationChart();
							this.initProtocolTypeChart();
							this.initOrderChart();
						});
					}
					this.$loading().close();
				} catch (err) {
					// 失败时使用假数据
					this.$message.error(err);
					this.$loading().close();
				} finally {
					this.loading = false;
				}
			},

			// 处理统计数据 - 修复字段映射问题
			processStatisticsData(data) {
				console.log('后端返回的数据:', data);
				
				// 顶部统计数据 - 直接使用后端返回的字段名
				this.data.num1 = data.num1 || 0;
				this.data.num2 = data.num2 || 0;
				this.data.num3 = data.num3 || 0;
				this.data.num4 = data.num4 || 0;

				// 地图数据 - 注意后端返回的是 carLocationData，不是 locationStats
				if (data.carLocationData && data.carLocationData.length > 0) {
					this.data.carLocationData = data.carLocationData.map(item => ({
						name: item.location || '未知地区',
						value: item.count || 0
					}));
				} else {
					this.data.carLocationData = [];
				}

				// 协议类型数据 - 注意后端返回的是 protocolTypeData
				if (data.protocolTypeData && data.protocolTypeData.length > 0) {
					this.data.protocolTypeData = data.protocolTypeData.map(item => ({
						name: item.protocolType || '未知类型',
						value: item.count || 0
					}));
				} else {
					this.data.protocolTypeData = [];
				}

				// 时间趋势数据 - 注意后端返回的是 timeTrendData
				if (data.timeTrendData && data.timeTrendData.length > 0) {
					this.data.timeTrendData = {
						title: data.timeTrendData.map(item => item.intervalUnit || ''),
						sales: data.timeTrendData.map(item => Number(item.amount || 0)),
						orders: data.timeTrendData.map(item => Number(item.quantity || 0))
					};
				} else {
					this.data.timeTrendData = {
						title: [],
						sales: [],
						orders: []
					};
				}
				
				console.log('处理后的地图数据:', this.data.carLocationData);
				console.log('处理后的协议类型数据:', this.data.protocolTypeData);
				console.log('处理后的趋势数据:', this.data.timeTrendData);
			},

			// 初始化投保车辆所属地分布地图
			initCarLocationChart() {
				const chartDom = document.getElementById('carLocationChart');
				if (!chartDom) return;

				if (this.charts.carLocationChart) {
					this.charts.carLocationChart.dispose();
				}

				// 注册中国地图
				echarts.registerMap('china', chinaMap);

				const myChart = echarts.init(chartDom);
				this.charts.carLocationChart = myChart;

				const carLocationData = this.data.carLocationData || [];

				const option = {
					title: {
						text: '',
						subtext: '',
						left: 'center',
						textStyle: {
							color: '#666'
						}
					},
					tooltip: {
						trigger: 'item',
						formatter: function(params) {
							if (params.data && params.data.value) {
								return params.name + '<br/>车辆数量：' + params.data.value + '辆';
							}
							return params.name || '';
						}
					},
					visualMap: {
						min: 0,
						max: Math.max(...carLocationData.map(item => item.value), 100),
						left: 'left',
						top: 'bottom',
						text: ['高', '低'],
						calculable: true,
						inRange: {
							color: ['#e0ffff', '#006edd']
						},
						textStyle: {
							color: '#666'
						}
					},
					series: [{
						name: '投保车辆数量',
						type: 'map',
						map: 'china',
						roam: true, // 允许缩放和平移
						zoom: 1.8, // 初始缩放级别
						label: {
							show: true,
							fontSize: 10,
							color: '#333'
						},
						itemStyle: {
							areaColor: '#f5f5f5',
							borderColor: '#ccc',
							borderWidth: 1
						},
						emphasis: {
							label: {
								color: '#fff',
								fontSize: 12,
								fontWeight: 'bold'
							},
							itemStyle: {
								areaColor: '#006edd'
							}
						},
						data: carLocationData
					}]
				};

				myChart.setOption(option);
			},

			// 初始化协议类型分析饼图
			initProtocolTypeChart() {
				const chartDom = document.getElementById('userOrderChart');
				if (!chartDom) return;

				if (this.charts.userOrderChart) {
					this.charts.userOrderChart.dispose();
				}

				const myChart = echarts.init(chartDom);
				this.charts.userOrderChart = myChart;

				const protocolTypeData = this.data.protocolTypeData || [];

				const option = {
					tooltip: {
						trigger: 'item',
						formatter: '{a} <br/>{b}: {c} ({d}%)'
					},
					legend: {
						orient: 'vertical',
						left: 'left',
						top: 'center',
						textStyle: {
							fontSize: 12
						}
					},
					series: [{
						name: '协议类型分析',
						type: 'pie',
						radius: ['40%', '70%'],
						avoidLabelOverlap: false,
						itemStyle: {
							borderRadius: 10,
							borderColor: '#fff',
							borderWidth: 2
						},
						label: {
							show: false,
							position: 'center'
						},
						emphasis: {
							label: {
								show: true,
								fontSize: 16,
								fontWeight: 'bold'
							}
						},
						labelLine: {
							show: false
						},
						data: protocolTypeData
					}]
				};

				myChart.setOption(option);
			},

			// 初始化保单走势图
			initOrderChart() {
				const chartDom = document.getElementById('orderChart');
				if (!chartDom) return;

				if (this.charts.orderChart) {
					this.charts.orderChart.dispose();
				}

				const myChart = echarts.init(chartDom);
				this.charts.orderChart = myChart;

				const orderChartData = this.data.timeTrendData || {};
				const titles = orderChartData.title || [];
				const sales = orderChartData.sales || [];
				const orders = orderChartData.orders || [];

				const option = {
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'cross',
							crossStyle: {
								color: '#999'
							}
						},
						formatter: function(params) {
							let result = params[0].name + '<br/>';
							params.forEach(item => {
								if (item.seriesName === '保费金额') {
									result += item.marker + item.seriesName + ': ¥' + item.value.toLocaleString() + '<br/>';
								} else {
									result += item.marker + item.seriesName + ': ' + item.value + '单<br/>';
								}
							});
							return result;
						}
					},
					legend: {
						data: ['保费金额', '协议数量']
					},
					grid: {
						left: '3%',
						right: '4%',
						bottom: '3%',
						containLabel: true
					},
					xAxis: [{
						type: 'category',
						data: titles,
						axisPointer: {
							type: 'shadow'
						},
						axisLabel: {
							rotate: 45
						}
					}],
					yAxis: [{
						type: 'value',
						name: '保费金额',
						axisLabel: {
							formatter: '¥{value}'
						}
					}, {
						type: 'value',
						name: '协议数量',
						axisLabel: {
							formatter: '{value} 单'
						}
					}],
					series: [{
						name: '保费金额',
						type: 'bar',
						barWidth: '60%',
						data: sales,
						itemStyle: {
							color: '#2280fd'
						}
					}, {
						name: '协议数量',
						type: 'line',
						yAxisIndex: 1,
						data: orders,
						itemStyle: {
							color: '#44d994'
						}
					}]
				};

				myChart.setOption(option);
			},

			// 窗口大小变化时重新调整图表
			handleResize() {
				Object.values(this.charts).forEach(chart => {
					if (chart && typeof chart.resize === 'function') {
						chart.resize();
					}
				});
			}
		},

		beforeDestroy() {
			// 销毁所有图表实例
			Object.values(this.charts).forEach(chart => {
				if (chart && typeof chart.dispose === 'function') {
					chart.dispose();
				}
			});
			// 移除事件监听
			window.removeEventListener('resize', this.handleResize);
		}
	}
</script>

<style scoped>
	.home {
		padding: 20px;
		background-color: #f5f7fa;
		min-height: auto;
		overflow-y: auto;
	}
	
	.header-row {
		display: flex;
		justify-content: space-between;
		align-items: center;
		width: 100%;
		margin-bottom: 20px;
	}
	
	.page-title {
		font-size: 20px;
		font-weight: 600;
		color: #333;
	}

	.filter-content {
		padding: 0 0 20px;
	}

	.filter-group {
		display: flex;
		align-items: center;
		gap: 15px;
		flex-wrap: wrap;
		flex: 1;
		justify-content: flex-end;
	}

	.time-type-select {
		width: 150px;
	}
	
	.time-type-select :deep(.el-input__inner) {
		border-radius: 6px;
		border: 1px solid #dcdfe6;
		height: 36px;
		line-height: 36px;
	}
	
	.time-type-select :deep(.el-input__inner:hover) {
		border-color: #c0c4cc;
	}
	
	.time-type-select :deep(.el-input__inner:focus) {
		border-color: #409eff;
	}

	.time-radio-group {
		min-width: 400px;
		display: flex;
		align-items: center;
		flex-wrap: wrap;
	}
	
	.time-radio-group :deep(.el-radio-button) {
		display: inline-flex;
		align-items: center;
	}
	
	.time-radio-group :deep(.el-radio-button__inner) {
		border-radius: 4px;
		padding: 8px 15px;
		height: 36px;
		line-height: 20px;
		border: 1px solid #dcdfe6;
		margin-right: 8px;
		margin-bottom: 0;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	
	.time-radio-group :deep(.el-radio-button:first-child .el-radio-button__inner) {
		border-radius: 4px;
	}
	
	.time-radio-group :deep(.el-radio-button:last-child .el-radio-button__inner) {
		border-radius: 4px;
	}
	
	.time-radio-group :deep(.el-radio-button__orig-radio:checked + .el-radio-button__inner) {
		background-color: #409eff;
		border-color: #409eff;
		color: #fff;
		box-shadow: none;
	}
	
	.time-radio-group :deep(.el-radio-button__inner:hover) {
		color: #409eff;
	}

	.date-picker-group {
		display: flex;
		align-items: center;
		gap: 10px;
	}
	
	.date-picker-group :deep(.el-range-editor) {
		width: 300px;
		height: 36px;
		border-radius: 6px;
		display: flex;
		align-items: center;
	}
	
	.date-picker-group :deep(.el-range-editor .el-range-input) {
		height: 34px;
		line-height: 34px;
	}

	.search-btn {
		height: 36px;
		padding: 0 20px;
		border-radius: 6px;
		background-color: #409eff;
		color: #fff;
		border: 1px solid #409eff;
		transition: all 0.3s;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	
	.search-btn:hover {
		background-color: #66b1ff;
		border-color: #66b1ff;
		transform: translateY(-1px);
		box-shadow: 0 4px 12px rgba(64, 158, 255, 0.2);
	}
	
	.search-btn:active {
		background-color: #3a8ee6;
		border-color: #3a8ee6;
		transform: translateY(0);
	}

	.content {
		background-color: #fff;
		border-radius: 8px;
		padding: 20px;
		margin-bottom: 20px;
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
	}
	
	.content2 {
		padding: 0 0 20px;
	}

	.num-box {
		display: grid;
		grid-template-columns: repeat(4, 1fr);
		gap: 20px;
		margin-bottom: 20px;
	}

	.num-item {
		background: #fff;
		border-radius: 8px;
		padding: 24px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
		transition: transform 0.3s ease;
	}

	.num-item:hover {
		transform: translateY(-5px);
	}

	.num-item-left {
		display: flex;
		flex-direction: column;
		align-items: center;
		text-align: center;
	}

	.num-item-icon {
		width: 50px;
		height: 50px;
		border-radius: 8px;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-bottom: 12px;
		font-size: 24px;
		color: #fff;
	}

	.num-item-icon.money {
		background-color: #67c23a;
	}

	.num-item-icon.user {
		background-color: #409eff;
	}

	.num-item-icon.order {
		background-color: #ffba00;
	}

	.num-item-icon.refund {
		background-color: #ff4d4f;
	}

	.num-item-name {
		color: #909399;
		font-size: 14px;
	}

	.num-item-value {
		color: #303133;
		font-size: 24px;
		font-weight: 500;
		text-align: right;
	}

	.separate-content {
		display: grid;
		grid-template-columns: 1fr 1fr;
		gap: 20px;
		margin-bottom: 20px;
	}

	.map-chart,
	.pie-chart,
	.element {
		background: #fff;
		border-radius: 8px;
		padding: 20px;
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
		display: flex;
		flex-direction: column;
		min-height: 450px;
	}

	.title {
		font-size: 16px;
		font-weight: 500;
		color: #303133;
		margin-bottom: 16px;
		padding-bottom: 12px;
		flex-shrink: 0;
	}

	.map-chart .echart,
	.pie-chart .echart {
		width: 100%;
		flex: 1;
		min-height: 350px;
	}

	.element .echart {
		width: 100%;
		flex: 1;
		min-height: 300px;
	}

	@media (max-width: 1200px) {
		.header-row {
			flex-direction: column;
			align-items: flex-start;
			gap: 15px;
		}
		
		.filter-group {
			width: 100%;
			justify-content: flex-start;
		}
		
		.time-radio-group {
			min-width: 100%;
		}
		
		.num-box {
			grid-template-columns: repeat(2, 1fr);
		}

		.separate-content {
			grid-template-columns: 1fr;
		}
		
		.map-chart,
		.pie-chart {
			min-height: 400px;
		}
		
		.map-chart .echart,
		.pie-chart .echart {
			min-height: 320px;
		}
	}

	@media (max-width: 992px) {
		.filter-group {
			flex-direction: column;
			align-items: stretch;
			gap: 15px;
		}
		
		.time-type-select {
			width: 100%;
		}
		
		.time-radio-group {
			min-width: 100%;
			width: 100%;
		}
		
		.time-radio-group :deep(.el-radio-button) {
			flex: 1;
			min-width: calc(33.333% - 8px);
		}
		
		.time-radio-group :deep(.el-radio-button__inner) {
			width: 100%;
			box-sizing: border-box;
		}

		.date-picker-group {
			width: 100%;
			justify-content: space-between;
		}
		
		.date-picker-group :deep(.el-range-editor) {
			width: calc(100% - 100px);
		}
	}

	@media (max-width: 768px) {
		.home {
			padding: 10px;
		}
		
		.header-row {
			gap: 10px;
		}

		.filter-group {
			width: 100%;
		}
		
		.time-radio-group :deep(.el-radio-button) {
			min-width: calc(50% - 8px);
		}

		.num-box {
			grid-template-columns: 1fr;
		}

		.num-item {
			padding: 20px;
			flex-direction: column;
			text-align: center;
		}
		
		.num-item-left {
			margin-bottom: 15px;
		}
		
		.num-item-value {
			text-align: center;
			font-size: 22px;
		}

		.map-chart .echart,
		.pie-chart .echart {
			min-height: 280px;
		}
		
		.element .echart {
			min-height: 250px;
		}

		.content,
		.map-chart,
		.pie-chart,
		.element {
			padding: 15px;
		}
		
		.map-chart,
		.pie-chart {
			min-height: 380px;
		}

		.num-item-icon {
			width: 45px;
			height: 45px;
			font-size: 22px;
			margin-bottom: 10px;
		}

		.num-item-value {
			font-size: 20px;
			color: #333333;
		}
		
		.date-picker-group {
			flex-direction: column;
			align-items: stretch;
			gap: 10px;
		}
		
		.date-picker-group :deep(.el-range-editor) {
			width: 100%;
		}
		
		.search-btn {
			width: 100%;
		}
	}
</style>